export default __webpack_public_path__ + "static/media/q25.8740dd6f.png";